import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import PageHeader from '../../../components/owner/PageHeader';
import { fetchMemberById, updateMember } from '../../../services/receptionist/receptionistApi';
import { fetchBranchNames } from '../../../services/gym/catalogApi';
import { usePanelToast } from '../../../context/PanelToastContext';
import { memberToFormData } from './memberData';
import MemberForm from './MemberForm';
import '../../owner/ownerPages.css';
import './members.css';

function EditMember() {
  const { id } = useParams();
  const navigate = useNavigate();
  const toast = usePanelToast();
  const [member, setMember] = useState(null);
  const [branchOptions, setBranchOptions] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const [data, branches] = await Promise.all([fetchMemberById(id), fetchBranchNames()]);
        if (active) {
          setMember(data);
          setBranchOptions(branches);
        }
      } catch (err) {
        if (active) setError(err.message || 'Failed to load member');
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => { active = false; };
  }, [id]);

  if (loading) return <p className="owner-placeholder-text">Loading member...</p>;
  if (!member) {
    navigate('/admin/members', { replace: true });
    return null;
  }

  const handleSubmit = async (form) => {
    try {
      setSaving(true);
      setError('');
      await updateMember(id, { ...form, gymId: member.gymId });
      toast.showUpdated('Member');
      navigate('/admin/members');
    } catch (err) {
      setError(err.message || 'Failed to update member');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      <PageHeader title="Edit Member" subtitle={`Editing: ${member.name}`} />
      {error && <p className="owner-placeholder-text owner-mb-16" style={{ color: 'var(--owner-danger, #dc2626)' }}>{error}</p>}
      <div className="owner-card member-form-card">
        <MemberForm
          initialData={memberToFormData(member)}
          submitLabel={saving ? 'Saving…' : 'Save Changes'}
          branchOptions={branchOptions}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/members')}
        />
      </div>
    </div>
  );
}

export default EditMember;
